import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

import { TStationCode } from 'dataSources/Typicode/stations';

export const updateSelectedStationOnRoute = (stations: TStationCode[]): AnyAction =>
  stationsActions.setSelectedStation(stations);
